/**
 * Decodes a base64 payload returned by the API (document, preview) into a Blob of the given type.
 * Throws a DOMException when the payload is not valid base64: the caller decides what to show.
 *
 * @example URL.createObjectURL(base64ToBlob(document.body, 'application/pdf'))
 */
const base64ToBlob = (base64: string, type: string): Blob =>
  new Blob([Uint8Array.from(atob(base64), (char) => char.codePointAt(0) ?? 0)], { type });

export default base64ToBlob;
